import React, { useContext, useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
// import Datepicker from 'react-datepicker';
import Select from "react-select";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { Get, JENIS_DUSUN, Post } from "../../function/Koneksi";
import { Tanggal } from "../../function/Format";
import { generateAlamat } from "../../function/Format";

const ModalSuratAhliWaris = ({
  data,
  optionData,
  setAlert,
  isOpen,
  setIsOpen,
  statusRefresh,
  setStatusRefresh,
  propsData,
  kiosk
}) => {
  const dateFormat = require("dateformat");

  const frmDex = {
    uuid: "",
    id_jenis: "",
    nik_pelapor: "",
    nik: "",
    kk: "",
    nama: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    jenis_kelamin: "",
    pekerjaan: "",
    pendidikan_terakhir: "",
    kewarganegaraan: "",
    agama: "",
    alamat: "",
    alamat_kk: "",
    status_perkawinan: "",
    waktu_meninggal: "",
    tempat_meninggal: "",
    sebab_meninggal: "",

    nik2: "",
    nama2: "",
    tempat_lahir2: "",
    tanggal_lahir2: "",
    jenis_kelamin2: "",
    pekerjaan2: "",
    pendidikan_terakhir2: "",
    kewarganegaraan2: "",
    agama2: "",
    alamat2: "",
    alamat_kk2: "",
    status_perkawinan2: "",
    waktu_meninggal2: "",
    tempat_meninggal2: "",
    sebab_meninggal2: "",
    detail: [],

    nik_ahli_waris: "",
    nama_ahli_waris: "",
    jk_ahli_waris: "",
    tempat_lahir_ahli_waris: "",
    pekerjaan_ahli_waris: "",
    shdk_ahli_waris: "",
    tgl_lahir_ahli_waris: new Date()
  };

	const initFormData = {
		frmNik: optionData.frmNik,
    frmPkr: optionData.frmPkr,
		frmShdk: optionData.frmShdk,
		frmNik3: optionData.frmNik3,
		nikStat: null,
		nik2Stat: null,
		nik3Stat: null,
		shdk_aw: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			dataPenduduk2: "none",
      ahliWarisManual: "none",
      frmPreviewDraft: false,
		},
		meninggal2: "none",
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
    formAhliWaris: "none",
    // Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

  const [formData, setFormData] = useState(initFormData);
  const [props, setProps] = useState(propsData);
  const [kioskMode, setKioskMode] = useState(kiosk)
  const [dt, setDt] = useState(data ? data : frmDex);

  useEffect(() => {
    if (document.getElementById("modalForm")) {
      document.getElementById("modalForm").reset();
    }
    
    setDt(data ? data : frmDex);
    setFormData(
      data
        ? {
            ...initFormData,
            nikStat: optionData.nikStat,
            nik2Stat: optionData.nik2Stat,
            frmNik2: optionData.frmNik2,
            frmNik3: optionData.frmNik3,
            frmPkr: optionData.frmPkr,
            formAhliWaris: optionData.formAhliWaris,
            meninggal2: optionData.meninggal2,
            status: optionData.status
          }
        : initFormData
    );
  }, [isOpen]);

  const requireTanggalAhliWaris = () => {
    if (formData.formAhliWaris === "none") {
      return false;
    } else {
      return true;
    }
  };

  const handleSelectChange = (e, fld) => {
    if (e) {
      setDt({
        ...dt,
        [fld]: e
      });
    }
    else{
      setDt({
        ...dt,
        [fld]: ""
      })
    }
  };

  const handleInputChange = (e, fld) => {
    setDt({
      ...dt,
      [fld]: e.target.value
    });
  };

  const handleInputChangeNIK = (e, fld) => {
    if (e && kioskMode == false) {
      let nikStat = { value: e, label: e };

      Post("penduduk", null, { nik: e }, datanik => {
        let frmNik = [];
        datanik.data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + " (" + dt.nama + ")" });
        });

        switch (fld) {
          case "nik":
            setFormData({
              ...formData,
              frmNik,
              nikStat
            });
            break;
          case "nik2":
            setFormData({
              ...formData,
              frmNik2: frmNik,
              nik2Stat: nikStat
            });
            break;

          default:
            break;
        }
      });
    }
  };

  const dataAhliWaris = () => {
    let ahliWarisManual = "block";

    let formAhliWaris = formData.formAhliWaris === "" ? "none" : "";

    if (formAhliWaris !== "") {
      ahliWarisManual = "none";
    }

    setDt({
      ...dt,
      // detail: [],
      nik_ahli_waris: "",
      nama_ahli_waris: "",
      jk_ahli_waris: null,
      tgl_lahir_ahli_waris: null,
      tempat_lahir_ahli_waris: "",
      pekerjaan_ahli_waris: null,
      shdk_ahli_waris: ""
    });

    setFormData({
      ...formData,
      status: {
        ...formData.status,
        ahliWarisManual
      },
      formAhliWaris,
      nik3Stat: null
    });
  };

  const changeInputText = (e, fld) => {
    setDt({
      ...dt,
      [fld]: e.target.value
    });
  };

  const getPenduduk = (e, sel, jns) => {
    if (e) {
      
      if (kioskMode) {
        props.setLoadingPreview(true)
      }
      else{
        setAlert({
          loadingPreview: true
        })
      }

			Get("penduduk/find", e.value, data => {
        if(data.results){
          const alamat = generateAlamat(data.results);
          let alamat_kk = "";
      
          if(data.results.data_kk){
            alamat_kk = data.results.data_kk.alamat
          }

          if (jns === "pelapor") {
            Get("penduduk/kk/" + data.results.id_kk, null, dtkk => {
              let frmNik3 = [];
              dtkk.results.forEach(val => {
                frmNik3.push({
                  value: val.id,
                  label: val.id + " (" + val.nama + ")"
                });
              });

              setFormData({
                ...formData,
                nikStat: e,
                frmNik2: frmNik3,
                frmNik3,
                status: {
                  ...formData.status,
                  dataPenduduk: "block"
                }
              });
              setDt({
                ...dt,
                nik: e.value,
                nik_pelapor: e.value,
                kk: data.results.id_kk,
                nama: data.results.nama,
                tempat_lahir: data.results.tempat_lahir,
                tanggal_lahir: new Date(data.results.tanggal_lahir),
                pekerjaan: data.results.data_pekerjaan.nama,
                pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                agama: data.results.data_agama.nama,
                status_perkawinan: data.results.status_perkawinan,
                jenis_kelamin: data.results.jk,
                alamat: alamat,
                alamat_kk: alamat_kk,
                kewarganegaraan: "WNI",
                detail: []
              });

              if (kioskMode) {
                props.setLoadingPreview(false)
              }
              else{
                setAlert({
                  loadingPreview: false
                })
              }
            });

          } else if (jns === "pelapor2") {
            setFormData({
              ...formData,
              nik2Stat: e,
              status: {
                ...formData.status,
                dataPenduduk2: "block",
              },
            })
            setDt({
              ...dt,
              nik2: e.value,
              nama2: data.results.nama,
              tempat_lahir2: data.results.tempat_lahir,
              tanggal_lahir2: new Date(
                data.results.tanggal_lahir
              ),
              pekerjaan2: data.results.data_pekerjaan.nama,
              pendidikan_terakhir2: data.results.data_pendidikan_terakhir.nama,
              agama2: data.results.data_agama.nama,
              status_perkawinan2: data.results.status_perkawinan,
              jenis_kelamin2: data.results.jk,
              alamat2: alamat,
              alamat_kk2: alamat_kk,
              kewarganegaraan2: 'WNI',
              waktu_meninggal2: new Date(),
              tempat_meninggal2: "",
              sebab_meninggal2: ""
            })

            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
          } else if (jns === "pengikut") {
            let detail = dt.detail
            detail.push({
              nik: e.value,
              nama: data.results.nama,
              jk: data.results.jk,
              tanggal_lahir: data.results.tanggal_lahir,
              tempat_lahir: data.results.tempat_lahir,
              pekerjaan: data.results.data_pekerjaan.nama,
              alamat: alamat,
              alamat_kk: alamat_kk,
              // shdk: formData.frmShdk[data.results.shdk],
              shdk: data.results.data_shdk.nama,
              keterangan: "",
            })

            setDt({
              ...dt,
              detail
            })

            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
          }
        }
        else{
          if (kioskMode) {
            props.setLoadingPreview(false)
          }
          else{
            setAlert({
              loadingPreview: false
            })
          }
        }
      });
    } else {
      switch (jns) {
        case "pelapor":
          setDt(frmDex);
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPenduduk: "none"
            },
            nikStat: null,
            nik2Stat: null,
            frmNik2: [],
            frmNik3: []
          });
          break;
        case "pengikut":
          setFormData({
            ...formData,
            nik3Stat: null
          });
          break;
        default:
          break;
      }
    }
  };

  const hapusDetail = i => {
    // let currDetail = dt.detail
    let newDetail = dt.detail.splice(i, 1);

    setDt({
      ...dt,
      detail: dt.detail
    });
  };

  const tambahMeninggal = e => {
    // e.preventDefault();
    if (formData.meninggal2 === "none") {
      setDt({
        ...dt,
        nama2: "",
        tanggal_lahir2: "",
        tempat_lahir2: "",
        agama2: "",
        pekerjaan2: "",
        kewarganegaraan2: "",
        alamat2: "",
        alamat_kk2: "",
        jenis_kelamin2: "",
        status_perkawinan2: "",
        waktu_meninggal2: new Date(),
        tempat_meninggal2: "",
        sebab_meninggal2: ""
      });
      setFormData({
        ...formData,
        meninggal2: "inherit",
        nik2Stat: null,
        status: {
          ...formData.status,
          dataPenduduk2: "none"
        }
      });
    } else {
      setDt({
        ...dt,
        nama2: "",
        tanggal_lahir2: "",
        tempat_lahir2: "",
        agama2: "",
        pekerjaan2: "",
        kewarganegaraan2: "",
        alamat2: "",
        alamat_kk2: "",
        jenis_kelamin2: "",
        status_perkawinan2: "",
        waktu_meninggal2: new Date(),
        tempat_meninggal2: "",
        sebab_meninggal2: "",
      });
      setFormData({
        ...formData,
        meninggal2: "none",
        nik2Stat: null,
        status: {
          ...formData.status,
          dataPenduduk2: "none"
        }
      });

      // this.state.status.dataPenduduk2 = "none";
      // this.setState({
      //   meninggal2: "none",
      //   nik2Stat: null,
      // });
      // this.forceUpdate();
    }
  };

  const tambahwaris = e => {
    e.preventDefault();

    if (kioskMode){
      props.setLoadingPreview(true)
    }
    else{
      setAlert({
        loadingPreview: true
      })
    }

    let cekForm = false;
    
    if(dt.nik_ahli_waris && 
      dt.nama_ahli_waris && 
      dt.jk_ahli_waris &&
      dt.tgl_lahir_ahli_waris &&
      dt.tempat_lahir_ahli_waris &&
      dt.pekerjaan_ahli_waris &&
      dt.shdk_ahli_waris
    ){
      cekForm = true
    }

    if(cekForm){
      let detail = dt.detail;
      detail.push({
        nik: dt.nik_ahli_waris,
        nama: dt.nama_ahli_waris,
        jk: dt.jk_ahli_waris.value,
        tanggal_lahir: dt.tgl_lahir_ahli_waris,
        tempat_lahir: dt.tempat_lahir_ahli_waris,
        pekerjaan: dt.pekerjaan_ahli_waris.label,
        shdk: dt.shdk_ahli_waris.label,
        keterangan: ""
      });
      setDt({
        ...dt,
        detail,
        nik_ahli_waris: "",
        nama_ahli_waris: "",
        jk_ahli_waris: null,
        tgl_lahir_ahli_waris: null,
        tempat_lahir_ahli_waris: "",
        pekerjaan_ahli_waris: null,
        shdk_ahli_waris: ""
      });
      setFormData({
        ...formData,
        status: {
          ...formData.status,
          ahliWarisManual: "none"
        },
        formAhliWaris: "none",
        nik3Stat: null
      });

      if (kioskMode){
        props.setLoadingPreview(false)
      }
      else{
        setAlert({
          loadingPreview: false
        })
      }
    }
    else{
      if (kioskMode){
				props.getAntrian('Surat Keterangan Ahli Waris', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				setAlert({
					loadingPreview: false
				})
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert(alertData)
			}
    }
  };

  const simpan = e => {
    e.preventDefault();
    
    if (kioskMode){
      props.setLoadingPreview(true)
    }
    else{
      setAlert({
        loadingPreview: true
      })
    }

    let validasiMeninggal2 = false
    if(formData.meninggal2 !== "none" || ""){
      if(formData.nik2Stat){
        validasiMeninggal2 = true
      }
    }else{
      validasiMeninggal2 = true
    }

    if (formData.nikStat && validasiMeninggal2 && dt.detail.length > 0) {
      let bodyRaw = {
        ...dt,
        tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), "yyyy-mm-dd"),
        // tanggal_lahir2: dateFormat(new Date(dt.tanggal_lahir2), 'yyyy-mm-dd'),
        waktu_meninggal: dateFormat(
          new Date(dt.waktu_meninggal),
          "yyyy-mm-dd HH:MM"
        ),
        // waktu_meninggal2: document.getElementById('waktu_meninggal2').value,
        tempat_meninggal: dt.tempat_meninggal,
        tempat_meninggal2: dt.tempat_meninggal2,
        sebab_meninggal: dt.sebab_meninggal,
        sebab_meninggal2: dt.sebab_meninggal2,
      };
      // Jika ada tambahan data meninggal
      if (formData.nik2Stat) {
        bodyRaw = {
          ...bodyRaw,
          tanggal_lahir2: dateFormat(new Date(dt.tanggal_lahir2), "yyyy-mm-dd"),
          waktu_meninggal2: dateFormat(
            new Date(dt.waktu_meninggal2),
            "yyyy-mm-dd HH:MM"
          )
        };

        bodyRaw = {
          ...bodyRaw,
          nik: (bodyRaw.nik += "," + bodyRaw.nik2),
          nama: (bodyRaw.nama += "," + bodyRaw.nama2),
          jenis_kelamin: (bodyRaw.jenis_kelamin += "," + bodyRaw.jenis_kelamin2),
          tempat_lahir: (bodyRaw.tempat_lahir += "," + bodyRaw.tempat_lahir2),
          tanggal_lahir: (bodyRaw.tanggal_lahir += "," + bodyRaw.tanggal_lahir2),
          pekerjaan: (bodyRaw.pekerjaan += "," + bodyRaw.pekerjaan2),
          kewarganegaraan: (bodyRaw.kewarganegaraan +=
            "," + bodyRaw.kewarganegaraan2),
          agama: (bodyRaw.agama += "," + bodyRaw.agama2),
          alamat: (bodyRaw.alamat += "|" + bodyRaw.alamat2),
          alamat_kk: (bodyRaw.alamat_kk += "|" + bodyRaw.alamat_kk2),
          tempat_meninggal: (bodyRaw.tempat_meninggal +=
            "," + bodyRaw.tempat_meninggal2),
          sebab_meninggal: (bodyRaw.sebab_meninggal +=
            "," + bodyRaw.sebab_meninggal2),
          waktu_meninggal: (bodyRaw.waktu_meninggal +=
            "," + bodyRaw.waktu_meninggal2)
        };
      }

      // delete data meninggal2 from body raw
      delete bodyRaw.nik2;
      delete bodyRaw.nama2;
      delete bodyRaw.tempat_lahir2;
      delete bodyRaw.tanggal_lahir2;
      delete bodyRaw.jenis_kelamin2;
      delete bodyRaw.pekerjaan2;
      delete bodyRaw.pendidikan_terakhir2;
      delete bodyRaw.kewarganegaraan2;
      delete bodyRaw.agama2;
      delete bodyRaw.alamat2;
      delete bodyRaw.status_perkawinan2;
      delete bodyRaw.waktu_meninggal2;
      delete bodyRaw.tempat_meninggal2;
      delete bodyRaw.sebab_meninggal2;

      if (dt.uuid === "") {
        if (kioskMode) {
          bodyRaw.id_jenis = props.id_jenis
        } else {
          bodyRaw.id_jenis = props.location.state.uuid
        }
      }

      // let validasiPelapor = formData.nikStat;

      let psn = "";
      let resstat = 204;
      let metode = "create";
      if (bodyRaw.uuid === "") {
        psn = "Tambah";
        resstat = 201;
        bodyRaw.uuid = null;
      } else {
        psn = "Ubah";
        resstat = 200;
        metode = "update";
      }
      setAlert({
        loadingPreview: true
      });
      Post(
        "surat-keterangan/ahli-waris/" + metode,
        bodyRaw.uuid,
        bodyRaw,
        res => {
          // For testing
          if (props.resSubmit) {
            props.resSubmit(res.status);
          }
          // this.tutupForm();
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              btnForm: false,
              form: false
            }
          });
          setIsOpen(false);
          
          if (kioskMode) {
            if (res.status === resstat) {
              let dataAntrian = {
                nama: props.data.results.nama,
                nik: props.data.results.id,
                keterangan: '',
                uuid_surat:res.data.results.uuid_surat,
                kode_surat:res.data.results.kode_surat,
              };
      
              // Set Data Surat
              props.getDataSurat(res.data.results);
      
              setTimeout(function () {
                Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {

                  props.setLoadingPreview(false)

                  if (res2.code === 201) {
                    props.getAntrian('Surat Keterangan Ahli Waris', 'berhasil', false, dataAntrian);
                  }
                  else {
                    props.getAntrian('Surat Keterangan Ahli Waris', 'gagal');
                  }
                });
              }.bind(this),1000)
            }
            else{
              props.setLoadingPreview(false)
              props.getAntrian('Surat Keterangan Ahli Waris', 'gagal');
            }
          } else {
            if (res.status === resstat) {
              const alertData = {
                get_data_surat:{
                  uuid_surat:res.data.results.uuid_surat,
                  kode_surat:res.data.results.kode_surat,
                },
                status:{
                  frmPreviewDraft: true,
                  jenis_form: psn,
                }
                // show: true,
                // basicType: "success",
                // basicTitle: "Data Surat Keterangan Ahli Waris",
                // pesanAlert: "Berhasil " + psn + " Data",
                // successAlert: true
              };
              setAlert({
                loadingPreview: false
              })
              setAlert(alertData);
            } else {
              const alertData = {
                show: true,
                basicType: "danger",
                basicTitle: "Data Surat Keterangan Ahli Waris",
                pesanAlert: "Gagal " + psn + " Data"
              };
              setAlert({
                loadingPreview: false
              })
              setAlert(alertData);
            }
            // Refresh list
            setStatusRefresh(true);
          }
        }
      );
    } else {
      if (kioskMode){
				props.getAntrian('Surat Keterangan Ahli Waris', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
        setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeOnEsc={false}
      closeOnOverlayClick={true}
      style={{
        maxwidth: "unset"
      }}
      // styles={{
      // 	modal: {
      // 		width: '80%',
      // 		minWidth: '301px'
      // 	}
      // }}
    >
      <Form data-testid="form-create" className="theme-form" onSubmit={simpan}>
        <div className="modal-header">
          <h5 className="modal-title">
            {dt.uuid == "" ? "Tambah" : "Edit"} Surat Keterangan Ahli Waris
          </h5>
        </div>
        <div className="modal-body">
          <p>
            Data identitas akan terisi secara otomatis saat NIK dipilih. Jika
            ada ketidak sesuaian data, silakan ubah di data master penduduk.
          </p>
          <input
            className="form-control"
            id="uuid"
            type="hidden"
            placeholder=""
            defaultValue={dt.uuid}
          />
          <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
            <b>Data Penduduk Meninggal</b>
          </div>
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="nik">
                <b>NIK Penduduk</b>
              </Label>
              <div data-testid="selectNIK">
                <Select
                  inputId="nik"
                  classNamePrefix="select"
                  onChange={e => {
                    getPenduduk(e, "nik", "pelapor");
                  }}
                  defaultValue={formData.nikStat}
                  value={formData.nikStat}
                  name="NIK"
                  options={formData.frmNik}
                  placeholder="Pilih NIK"
                  onInputChange={e => handleInputChangeNIK(e, "nik")}
                  isClearable
                />
              </div>
            </Col>
          </FormGroup>
          <div style={{ display: formData.status.dataPenduduk }}>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Nama Penduduk</b>
                </Label>
                <input
                  className="form-control"
                  id="nama"
                  type="text"
                  placeholder="Nama Pemohon"
                  value={dt.nama}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Tempat Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tempat_lahir"
                  type="text"
                  placeholder="Tempat Lahir"
                  value={dt.tempat_lahir}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Tanggal Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tanggal_lahir"
                  type="text"
                  placeholder="Tanggal Lahir"
                  value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Alamat</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat_kk"
                  type="text"
                  placeholder="Alamat"
                  value={dt.alamat_kk}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Wilayah</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat"
                  type="text"
                  placeholder=""
                  value={dt.alamat}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
                <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
              </Col>
            </FormGroup>
          </div>
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="inputEmail3">
                <b>Waktu Meninggal</b>
              </Label>
              <Datetime
                inputProps={{
                  "data-testid": "waktu_meninggal",
                  placeholder: "Waktu Meninggal",
                  required: true
                }}
                inputId="waktu_meninggal"
                name="waktu_meninggal"
                locale="id-ID"
                timeFormat="HH:mm"
                dateFormat="DD/MM/yyyy"
                input={true}
                closeOnTab={true}
                initialValue={new Date(dt.waktu_meninggal)}
                value={new Date(dt.waktu_meninggal)}
                onChange={date => {
                  if (typeof date._isValid !== "undefined") {
                    let tgl = date.format("YYYY-MM-DD HH:mm:ss");
                    setDt({
                      ...dt,
                      waktu_meninggal: new Date(tgl)
                    });
                  }
                }}
              />
            </Col>
          </FormGroup>
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="inputEmail3">
                <b>Tempat Meninggal</b>
              </Label>
              <input
                data-testid="tempat meninggal"
                name="tempat_meninggal"
                className="form-control"
                id="tempat_meninggal"
                type="text"
                placeholder="Tempat Meninggal"
                defaultValue={dt.tempat_meninggal}
                onChange={e => changeInputText(e, "tempat_meninggal")}
                required
              />
            </Col>
          </FormGroup>
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="inputEmail3">
                <b>Sebab Meninggal</b>
              </Label>
              <input
                data-testid="sebab meninggal"
                name="sebab_meninggal"
                className="form-control"
                id="sebab_meninggal"
                type="text"
                placeholder="Sebab Meninggal"
                defaultValue={dt.sebab_meninggal}
                onChange={e => changeInputText(e, "sebab_meninggal")}
                required
              />
            </Col>
          </FormGroup>
          <FormGroup className="row">
            <Col sm="12">
              <button
                // href={() => false}
                data-testid="btnInputKematian"
                onClick={e => {
                  e.preventDefault();
                  // testing
                  // if (formData.meninggal2 === "none") {
                  // 	if (this.props.getJenisInput) {
                  // 		this.props.getJenisInput("tambah")
                  // 	}
                  // }
                  // else {
                  // 	if (this.props.getJenisInput) {
                  // 		this.props.getJenisInput("hapus")
                  // 	}
                  // }
                  tambahMeninggal();
                }}
                className={
                  formData.meninggal2 === "none"
                    ? "btn btn-sm btn-success"
                    : "btn btn-sm btn-danger"
                }
              >
                {formData.meninggal2 === "none"
                  ? "Tambah Data Meninggal"
                  : "Hapus Data Meninggal"}
              </button>
            </Col>
          </FormGroup>
          <div style={{ display: formData.meninggal2 }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
              <b>Data Penduduk Meninggal 2</b>
            </div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="] col-form-label" htmlFor="nik2">
                  <b>NIK Penduduk</b>
                </Label>
                <div data-testid="selectNIK2">
                  <Select
                    inputId="nik2"
                    classNamePrefix="select"
                    onChange={e => {
                      getPenduduk(e, "nik", "pelapor2");
                    }}
                    defaultValue={formData.nik2Stat}
                    value={formData.nik2Stat}
                    name="NIK2"
                    options={formData.frmNik2}
                    placeholder="Pilih NIK"
                    // onInputChange={e => handleInputChangeNIK(e, "nik2")}
                    isClearable
                  />
                </div>
              </Col>
            </FormGroup>
            <div style={{ display: formData.status.dataPenduduk2 }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Nama Penduduk</b>
                  </Label>
                  <input
                    className="form-control"
                    id="nama2"
                    type="text"
                    placeholder="Nama Pemohon"
                    value={dt.nama2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tempat Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tempat_lahir2"
                    type="text"
                    placeholder="Tempat Lahir"
                    value={dt.tempat_lahir2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tanggal_lahir2"
                    type="text"
                    placeholder="Tanggal Lahir"
                    value={new Date(dt.tanggal_lahir2).toLocaleDateString(
                      "id-ID"
                    )}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className=" col-form-label" htmlFor="inputEmail3">
                    <b>Alamat</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_kk"
                    type="text"
                    placeholder="Alamat"
                    value={dt.alamat_kk2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className=" col-form-label" htmlFor="inputEmail3">
                    <b>Wilayah</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat"
                    type="text"
                    placeholder=""
                    value={dt.alamat2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                  <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Waktu Meninggal</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "waktu_meninggal2",
                      placeholder: "Waktu Meninggal",
                      required: formData.status.dataPenduduk2 !== "none"
                    }}
                    inputId="waktu_meninggal2"
                    name="waktu_meninggal2"
                    locale="id-ID"
                    timeFormat="HH:mm"
                    dateFormat="DD/MM/yyyy"
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.waktu_meninggal2)}
                    value={new Date(dt.waktu_meninggal2)}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        let tgl = date.format("YYYY-MM-DD HH:mm:ss");
                        setDt({
                          ...dt,
                          waktu_meninggal2: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tempat Meninggal</b>
                  </Label>
                  <input
                    data-testid="tempat_meninggal2"
                    name="tempat_meninggal2"
                    className="form-control"
                    id="tempat_meninggal2"
                    type="text"
                    placeholder="Tempat Meninggal"
                    value={dt.tempat_meninggal2}
                    onChange={e => changeInputText(e, "tempat_meninggal2")}
                    required={
                      formData.status.dataPenduduk2 !== "none" ? true : false
                    }
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Sebab Meninggal</b>
                  </Label>
                  <input
                    data-testid="sebab_meninggal2"
                    name="sebab_meninggal2"
                    className="form-control"
                    id="sebab_meninggal2"
                    type="text"
                    placeholder="Sebab Meninggal"
                    value={dt.sebab_meninggal2}
                    onChange={e => changeInputText(e, "sebab_meninggal2")}
                    required={
                      formData.status.dataPenduduk2 !== "none" ? true : false
                    }
                  />
                </Col>
              </FormGroup>
            </div>
          </div>
          <hr />
          <div style={{ display: formData.status.dataPenduduk }}>
                <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                  <b>Data Ahli Waris</b>
                </div>
                <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label">
                    <b>Nik Ahli Waris</b>
                  </Label>
                  {formData.status.ahliWarisManual === "none" || "" ? (
                    <div data-testid="selectNIK3">
                      <Select
                        inputId="nik3"
                        classNamePrefix="select"
                        onChange={e => {
                          getPenduduk(e, "nik", "pengikut");
                        }}
                        defaultValue={formData.nik3Stat}
                        value={formData.nik3Stat}
                        name="NIK3"
                        options={formData.frmNik3}
                        placeholder="Pilih Anggota Keluarga"
                        // onInputChange={e => this.handleInputChangeNIK(e, "nik3")}
                        isClearable
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <input
                    data-testid="nik_ahli_waris"
                    name="nik_ahli_waris"
                    className="form-control"
                    id="nik_ahli_waris"
                    type={formData.status.ahliWarisManual === "none" || "" ? "hidden" : "text"}
                    pattern="\d{1,16}"
                    onChange={e => handleInputChange(e, "nik_ahli_waris")}
                    maxLength={16}
                    value={dt.nik_ahli_waris}
                    defaultValue={dt.nik_ahli_waris}
                    minLength={16}
                    required={formData.status.formAhliWaris === "none" || "" ? false : true}
                    placeholder="Masukkan NIK Ahli Waris (16 angka)"
                    // defaultValue={dt.detail.nik}
                    // value={dt.detail.nik}
                    // onChange={e => changeInputText(e, "nik_ayah", "ayah")}
                  />
                </Col>
                </FormGroup>
                <div style={{ display: formData.status.ahliWarisManual }}>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="inputEmail3">
                        <b>Nama</b>
                      </Label>
                      <input
                        data-testid="nama_ahli_waris"
                        name="nama_ahli_waris"
                        className="form-control"
                        id="nama_ahli_waris"
                        type="text"
                        onChange={e => handleInputChange(e, "nama_ahli_waris")}
                        value={dt.nama_ahli_waris}
                        defaultValue={dt.nama_ahli_waris}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        // readOnly={formData.formAhliWaris === "" ? false : true}
                        placeholder="Contoh : Toni"
                        //   defaultValue={dt.detail.nama}
                        //   value={dt.detail.nama}
                        //   style={
                        //     formData.formAhliWaris === ""
                        //       ? { backgroundColor: "" }
                        //       : { backgroundColor: "#c9d1d8" }
                        //   }
                        // disabled={formData.formAhliWaris === "" ? false : true}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="inputEmail3">
                        <b>Jenis Kelamin</b>
                      </Label>
                      <Select
                        inputId="jk_ahli_waris"
                        data-testid="jk_ahli_waris"
                        name="jk_ahli_waris"
                        // className="form-control"
                        id="jk_ahli_waris"
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        placeholder="Pilih Jenis Kelamin Ahli Waris"
                        // defaultValue={dt.jk_ahli_waris}
                        value={dt.jk_ahli_waris}
                        options={[
                          { label: "Laki-Laki", value: "Laki-Laki" },
                          { label: "Perempuan", value: "Perempuan" }
                        ]}
                        onChange={e => handleSelectChange(e, "jk_ahli_waris")}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="inputEmail3">
                        <b>Tanggal Lahir</b>
                      </Label>
                      {/* {formData.formAyah === "" ? ( */}
                      <Datetime
                        inputProps={{
                          "data-testid": "tgl_lahir_ahli_waris",
                          placeholder: "Pilih Tanggal Lahir Ahli Waris",
                          required: requireTanggalAhliWaris()
                        }}
                        inputId="tgl_lahir_ahli_waris"
                        name="tgl_lahir_ahli_waris"
                        locale="id-ID"
                        timeFormat={false}
                        dateFormat="DD/MM/yyyy"
                        input={true}
                        closeOnTab={true}
                        // initialValue={dt.tgl_lahir_ahli_waris}
                        // value={dt.tgl_lahir_ahli_waris}
                        onChange={date => {
                          if (typeof date._isValid !== "undefined") {
                            let tgl = date.format("YYYY-MM-DD");
                            setDt({
                              ...dt,
                              tgl_lahir_ahli_waris: new Date(tgl)
                            });
                          }
                        }}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label
                        className="col-form-label"
                        htmlFor="tempat_lahir_ahli_waris"
                      >
                        <b>Tempat Lahir</b>
                      </Label>
                      <input
                        data-testid="tempat_lahir_ahli_waris"
                        name="tempat_lahir_ahli_waris"
                        className="form-control"
                        id="tempat_lahir_ahli_waris"
                        type="text"
                        onChange={e =>
                          handleInputChange(e, "tempat_lahir_ahli_waris")
                        }
                        defaultValue={dt.tempat_lahir_ahli_waris}
                        value={dt.tempat_lahir_ahli_waris}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        // readOnly={formData.formAhliWaris === "" ? false : true}
                        placeholder="Contoh : Jakarta"
                        // style={{ backgroundColor: "#c9d1d8" }}
                      />
                      {/* )} */}
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="pekerjaan">
                        <b>Pekerjaan</b>
                      </Label>
                      <Select
                        inputId="pekerjaan"
                        classNamePrefix="select"
                        onChange={e =>
                          handleSelectChange(e, "pekerjaan_ahli_waris")
                        }
                        // value={dt.detail_surat.data_ibu.pekerjaan_ibu}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        name="pekerjaan_ahli_waris"
                        id="pekerjaan_ahli_waris"
                        options={formData.frmPkr}
                        // defaultValue={dt.pekerjaan_ahli_waris}
                        value={dt.pekerjaan_ahli_waris}
                        placeholder="Pilih Pekerjaan Ahli Waris"
                        isClearable
                      />
                      {/* )} */}
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className=" col-form-label" htmlFor="inputEmail3">
                        <b>Hubungan Ahli Waris</b>
                      </Label>
                      <Select
                        inputId="shdk_ahli_waris"
                        classNamePrefix="select"
                        name="shdk_ahli_waris"
                        id="shdk_ahli_waris"
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        value={dt.shdk_ahli_waris}
                        options={formData.frmShdk}
                        onChange={e => handleSelectChange(e, "shdk_ahli_waris")}
                        placeholder="Pilih Hubungan Ahli Waris"
                        isClearable
                        //   placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
                        //   defaultValue={dt.detail_surat.data_ayah.alamat_ayah}
                        //   value={dt.detail_surat.data_ayah.alamat_ayah}
                        //   onChange={e =>
                        //     changeInputText(e, "alamat_ayah", "ayah")
                        //   }
                        //   style={
                        //     formData.formAyah === ""
                        //       ? { backgroundColor: "" }
                        //       : { backgroundColor: "#c9d1d8" }
                        //   }
                        //   disabled={formData.formAyah === "" ? false : true}
                      />
                    </Col>
                  </FormGroup>
                  {/* <FormGroup className="row">
                      <Col sm="12">
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          <b>Agama Ayah</b>
                        </Label>
                        {formData.formAyah === "" ? (
                          // || dt.agama_ayah !== ""
                          <div data-testid="selectAgama">
                            <Select
                              inputId="agama_ayah"
                              classNamePrefix="select"
                              onChange={e => {
                                changeSelectValue(e, "agama_ayah", "ayah");
                              }}
                              value={dt.detail_surat.data_ayah.agama_ayah}
                              name="agama_ayah"
                              options={formData.frmAgm}
                              placeholder="Pilih Agama Ayah"
                              isClearable
                            />
                          </div>
                        ) : (
                          <input
                            id="agama_ayah"
                            type="text"
                            className="form-control"
                            readOnly
                            value={
                              dt.detail_surat.data_ayah.agama_ayah
                                ? dt.detail_surat.data_ayah.agama_ayah.label
                                : ""
                            }
                            style={{ backgroundColor: "#c9d1d8" }}
                          />
                        )}
                      </Col>
                    </FormGroup> */}
                  <button
                    type="button"
                    className="btn btn-primary-custom"
                    onClick={tambahwaris}
                    // disabled={formData.status.btnForm}
                  >
                    Simpan
                  </button>
                </div>

                <small id="emailHelp" className="form-text text-muted mb-3">
                  Data NIK {formData.formAhliWaris === "none" ? "tidak" : ""}{" "}
                  tersedia?{" "}
                  <span
                    style={{ cursor: "pointer", color: "#0000ff" }}
                    onClick={() => {
                      if (formData.formAhliWaris === "none") {
                        if (props.getJenisInput) {
                          props.getJenisInput("manual");
                        }
                      } else {
                        if (props.getJenisInput) {
                          props.getJenisInput("auto");
                        }
                      }
                      dataAhliWaris();
                    }}
                  >
                    Klik disini
                  </span>
                </small>


              {dt.detail.length > 0 ? (
                <>
                  <Label
                    className="col-sm-3 col-form-label"
                    style={{ fontWeight: "700" }}
                  >
                    Daftar Ahli Waris
                  </Label>
                  <Col sm="12" style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-stripes table-hovered">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Nama</th>
                          <th>Jenis Kelamin</th>
                          <th>Tempat/Tanggal Lahir</th>
                          <th>Pekerjaan</th>
                          <th>Hubungan Keluarga</th>
                          <th>
                            <i className="fa fa-trash"></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dt.detail.map((val, i) => {
                          let jk = "L";
                          if (val.jk === "Perempuan") {
                            jk = "P";
                          }
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{val.nama}</td>
                              <td>{jk}</td>
                              <td>
                                {val.tempat_lahir}, {Tanggal(val.tanggal_lahir)}
                              </td>
                              <td>{val.pekerjaan}</td>
                              <td>{val.shdk}</td>
                              <td>
                                <Button
                                  size="xs"
                                  onClick={() => hapusDetail(i)}
                                  color="danger"
                                  className="btn-icon"
                                >
                                  <i className="fa fa-trash"></i>
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Col>
                </>
              ) : (
                <div className="col-sm-12" style={{ marginTop: "20px" }}>
                  <h6 className="text-center">
                    Belum ada ahli waris yang ditambahkan
                  </h6>
                </div>
              )}
           
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              // Tutup modal
              setFormData({
                ...formData,
                status: {
                  ...formData.status,
                  form: false,
                  frmPreviewDraft: false,
									jenis_form: '',
                }
              });
              setIsOpen(false);
            }}
          >
            Tutup
          </button>
          <button
            data-testid="btnSubmitCreate"
            type="submit"
            className="btn btn-primary-custom"
            // disabled={formData.status.btnForm}
          >
            Simpan
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalSuratAhliWaris;
